import { createKeys } from '../../CRUD';

export const keys = createKeys('availabilities', 'Availability');
